import { createSelector } from '@ngrx/store';

import { getOrderSummary } from '../getOrderSummary';
import { isPayByPointsSelected } from '../../../creditCards/selectors/isPayByPointsSelected';
import { getActiveCardId } from '../../../creditCards/selectors/getActiveCardId';
import { canFulfillPaymentWithPointsOnly } from '../../../commonSelectors/payments';

export const shouldRequireTwoPaymentOptions = createSelector(
    isPayByPointsSelected,
    canFulfillPaymentWithPointsOnly,
    getActiveCardId,
    getOrderSummary,
    (payByPointsSelected, canFulfillPaymentWithPoints, cardId, orderSummary) => {
        const arePointsOnlyMethodWithLowBalance = !canFulfillPaymentWithPoints && cardId === OLO.Enums.PAYMENT_VENDOR_SERVICE.PAY_BY_POINTS;
        const areSurchargesEqualZero = orderSummary?.Surcharges.every((surcharge) => surcharge.Value === 0);
        const isEverythingRedeemableButHasSurcharges = canFulfillPaymentWithPoints && orderSummary?.Surcharges.length > 0 && !areSurchargesEqualZero;

        return payByPointsSelected && (arePointsOnlyMethodWithLowBalance || isEverythingRedeemableButHasSurcharges);
    },
);
